import React from "react";
interface props {
  className?: string;
}

function CrossIcon({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        fill="#000"
        d="M19.281 18.22a.75.75 0 11-1.061 1.061L12 13.061l-6.219 6.22A.75.75 0 114.72 18.22L10.94 12 4.72 5.781A.75.75 0 115.78 4.72l6.22 6.22 6.219-6.22A.75.75 0 1119.28 5.78l-6.22 6.22 6.22 6.219z"
      ></path>
    </svg>
  );
}

export default CrossIcon;
